module.exports = __webpack_public_path__ + "static/img/JP@3x.f5bc7364.jpg";